import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { InfoTip } from "@/components/app/Common";

export function StepStrip({ steps, active, onPick }) {
  if (!steps) return <div className="tl-skel h-[92px] rounded-[6px]" />;
  return (
    <nav aria-label="Hiring steps" data-testid="step-strip" data-tour="step-strip">
      <ol className="grid gap-2 sm:grid-cols-5">
        {steps.map((s, i) => {
          const on = active === s.n;
          return (
            <motion.li key={s.n} initial={{ opacity: 0, y: 6 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.04 }}>
              <button onClick={() => onPick(s.n)} aria-current={on ? "step" : undefined} data-testid={`step-${s.key}`}
                className={`flex h-full w-full flex-col gap-1 rounded-[6px] border px-4 py-3 text-left transition-colors ${on ? "border-brand bg-brand-tint/60" : "border-line bg-white hover:bg-surface-2"}`}>
                <span className="flex items-center gap-2 text-sm font-semibold">
                  <span className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-xs ${s.done ? "bg-success text-white" : on ? "bg-brand text-white" : "bg-surface-2 text-ink-secondary"}`} aria-hidden>
                    {s.done ? <Check size={13} /> : s.n}</span>
                  {s.title}
                  {s.needs > 0 && <span className="ml-auto rounded-full bg-brand px-2 py-0.5 text-[11px] font-medium text-white" data-testid={`step-needs-${s.key}`} aria-label={`${s.needs} need action`}>{s.needs}</span>}
                </span>
                <span className="text-xs text-ink-secondary" data-testid={`step-hint-${s.key}`}>{s.hint}</span>
                {s.subs.length > 0 && <span className="text-[11px] text-ink-muted">{s.subs.join(" · ")}</span>}
              </button>
            </motion.li>
          );
        })}
      </ol>
      {active && <p className="mt-2 flex items-center gap-1 text-xs text-ink-muted" data-testid="step-what">{steps[active - 1].what}<InfoTip text="Each candidate shows one Next step button. Use it to move them along without hunting through pages." /></p>}
    </nav>
  );
}
